var Analytics = require('@plaudit/analytics').Analytics;

var plauditConfig = (function($){
	return {
		body: $('body'),
		html: $('html'),
		win: $(window),
		currState: '',
		prevState: '',
		widthUnder: {
			'760': null,
			'640': null
		}
	};
})(jQuery);

var plauditUI = (function($){
	return {
		common: function(){
			(function trackBrowsingState(){
				var responsiveW = 760;

				function getState(){
					var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
					plauditConfig.widthUnder['760'] = !(width > 760);
					plauditConfig.widthUnder['640'] = !(width > 640);
					return width > responsiveW ? 'desktop' : 'responsive';
				}
				function setState(){
					plauditConfig.currState = getState();
				}
				function handleEvent() {
					plauditConfig.prevState = plauditConfig.currState;
					if (plauditConfig.currState !== getState()){
						setState();
					}
				}
				handleEvent()

				plauditConfig.win.on('resize.trackState', handleEvent);
			})(); // trackBrowsingState


			// Chat links
			$(".callout--chat, a[href$='#chat']").on('click', function(){
				if (typeof(window.LC_API) != "undefined"){
					window.LC_API.open_chat_window();
				}
			});
		} // common()




		,bannerSelector: function(elem) {
			var $elem = $(elem);
			if ($elem.length < 1){
				return;
			}
			$banners = $('.imageBGraphic');

			function hideShow( elem ){
				$banners.fadeOut(0).slideUp(100).filter('#bGraphic-'+ elem.find('option:selected').val() ).fadeIn(600);
			}
			hideShow($elem);

			$elem.addClass('js').on('change', function(){
				hideShow($(this));
			});
		} // bannerSelector()



		,cardFlip: function(){
			var $elem = $('.card .view.has-back');
			if ($elem.length < 1){
				return;
			}

			// var win = plauditConfig.win;
			// var	maxW = 640;
			// var	active = false;
			var elemClick = function(e) {
				e.preventDefault();
				var $set = $(this).find('.image-set');
				if ( $set.data('flip') ) {
					$set.data({flip: false}).removeClass('view-back');
					var imgSrc = $set.find('.front img').attr('src');
					Analytics.getInstance().trackEvent('Product Feature', 'Flip to Front', imgSrc, undefined, true);
				} else {
					$set.data({flip: true}).addClass('view-back');
					var imgSrc = $set.find('.back img').attr('src');
					Analytics.getInstance().trackEvent('Product Feature', 'Flip to Back', imgSrc, undefined, true);
				}
			}

			/* function attachEvents() {
				if ( active===true ){
					return;
				}
				$elem.on('click', elemClick);
			}
			function detachEvents() {
				if ( active===false ){
					return;
				}
				$elem.off('click', elemClick);
			}
			function handleEvents() {
				if (win.width() < maxW) {
					detachEvents();
					active = false;
				} else {
					attachEvents();
					active = true;
				}
			} 
			handleEvents();
			
			win.on('resize', handleEvents); */

			$elem.on('click', elemClick);
		} // cardFlip()


		,carousel: function(){
			var $elem = $('.carousel');
			if ($elem.length < 1){
				return;
			}

			var $carousel = $elem.find('.carousel__items');
			var carouselControls = '\
			<div class="carouselControls">\
				<a class="carouselControl--left" title="Previous"><span>Previous</span></a>\
				<a class="carouselControl--right" title="Next"><span>Next</span></a>\
			</div>\
			<span class="carouselPaginate"></span>';
			$carousel.after( carouselControls ).cycle({
				fx:  'fade'
				,sync: false
				,easing: 'swing'
				,timeout: 5000
				,speed: 500
				,slides: 'div.carousel__item'
				,pause: 1
				,pauseOnHover: true
				,manualTrump: 1
				,next:   '.carouselControl--right'
				,prev:   '.carouselControl--left'
				,pager:  '.carouselPaginate'
				,pagerActiveClass: 'active'
			});

			if ($('.carousel__item').length==1){
				$('.carouselControls').hide();
			}
		} // carousel()



		,copyToClipboard: function() {
			var onCopyLinkClick = function() {
				var targetId = this.dataset.clipboardTarget;
				var elem = document.getElementById(targetId);
				
				if (elem !== null) {
					var doc = document;
					if (typeof elem.select === "function") {
						elem.select();
					} else if (doc.body.createTextRange) { // ms
						var range = doc.body.createTextRange();
						range.moveToElementText(elem);
						range.select();
					} else if (window.getSelection) { // moz, opera, webkit
						var selection = window.getSelection();            
						var range = doc.createRange();
						range.selectNodeContents(elem);
						selection.removeAllRanges();
						selection.addRange(range);
					}
					document.execCommand("copy");
				}
			};
			var mutationObserver = new MutationObserver(function(mutations) {
				for (var m=0; m < mutations.length; m++) {
					var mutation = mutations[m];
					for (var i = 0; i < mutation.addedNodes.length; i++) {
						var addedNode = mutation.addedNodes[i];
						if (addedNode.classList.contains('copyToClipboard')) {
							if (!addedNode.classList.contains('copyToClipboard-setup')) {
								addedNode.classList.add('copyToClipboard-configured');
								addedNode.addEventListener("click", onCopyLinkClick, false);
							}
						} else {
							var children = addedNode.querySelectorAll('.copyToClipboard:not(.copyToClipboard-setup)');
							for (var j = 0; j < children.length; j++) {
								var item = children[j];
								item.classList.add('copyToClipboard-configured');
								item.addEventListener("click", onCopyLinkClick, false);
							}
						}
					}
				}
			});

			var copyLinks = document.querySelectorAll('.copyToClipboard');
			for (var i=0; i < copyLinks.length; i++) {
				var link = copyLinks[i];
				link.classList.add('copyToClipboard-configured');
				link.addEventListener("click", onCopyLinkClick, false);
			}

			var config = {childList: true, subtree: true};
			var surveyForms = document.querySelectorAll('main.survey');
			for (var i = 0; i < surveyForms.length; i++) {
				mutationObserver.observe(surveyForms[i], config);
			}
		} // copyToClipboard()


		,datePicker: function(){
			$( ".projectDateFieldArea input" ).datepicker( { dateFormat: 'M d, yy' } );
			$( ".dateFieldArea input" ).datepicker( { dateFormat: 'M d, yy' } );
		} // datePicker()


		,deleteFileButtonPrompt: function() {
			var button = $("#file-info").find(".delete-file-button")
			var confirmationMessage = "Are you sure you want to delete this file? (Note this won't delete the file from Amazon S3.)";

			button.on('click', function(){
				if ( !window.confirm(confirmationMessage) ) {
					return false;
				}
			})
		} // deleteButtonPrompt()

		,fileUploader: function(elem) {
			var $elem = $(elem).filter(function () {return !this.classList.contains('amazon-configured')});
			if ($elem.length < 1){
				return;
			}
			$elem.addClass('amazon-configured');

			$elem.amazonS3FileUploader({
				fail: function (e, data) {
					// Errors hardly ever happen.
					alert("Error: " + data.errorThrown + '\n\nEvent: ' + JSON.stringify(e) + '\n\nData: ' + JSON.stringify(data));
					console.log("Error: " + data.errorThrown + '\n\nEvent: ' + JSON.stringify(e) + '\n\nData: ' + JSON.stringify(data));
				}
			});
		} // fileUploader()



		,formCustomURL: function(elem) {
			var $elem = $(elem);
			if ($elem.length < 1){
				return;
			}
			var url = $elem.find('label + span');
			var user = $elem.parents('form').find("input[id*='\\:username']");
			if (user.length < 1){
				return;
			}
			var domain = url.data("domain");

			function updateValue(){
				var username = encodeURI(user.val())
				url.html( domain+'<strong>'+username+'</strong>' );
				url.data("copy", domain + username );
			}
			updateValue();

			user.on('keyup change', function(){
				updateValue();
			})
		} // formCustomURL()



		,responsiveMenu: function() {
			var win = plauditConfig.win;
			var html = plauditConfig.html;
			var body = plauditConfig.body;
			var config = {
				maxW: 760
				,menuActive: false
				,mainCSS: ''
				,mainTrigger: '#main-trigger'
				,menuCSS: 'hasOpenMenu'
				,menuTrigger: '#menu-trigger'
				,scrollCSS: 'isScrolled'
				,scrollH: 50
				,submenuOpenCSS: 'open'
				,submenuTarget: '#mainMenu .child-wrap'
				,submenuTrigger: '#mainMenu .hasChild > .link'
				,triggerEvent: 'touchstart.menu click.menu'
			};
			(function() {
				var c = config;

				function toggleMenu(evt) {
					evt.preventDefault();
					if (html.hasClass( c.menuCSS )){
						runSubmenu(150, function(){
							html.removeClass(c.menuCSS);
						});
					} else {
						runSubmenu(0, function(){
							html.addClass(c.menuCSS);
							var active = $(c.submenuTarget).filter('.active');
							if (active.length === 0) {
								openMenuNode(null);
							} else {
								active.each(function() {
									openMenuNode(this);
								});
							}
						});
					}
				}
				function runSubmenu(duration, callback) {
					$(c.submenuTarget).slideUp(duration).promise().done( callback );
				}
				function openMenuNode(elem) {
					var childWrapSelector = '> .child-wrap';
					var nodeItemSelector = "li";
					
					if (elem === null) {
						$(c.submenuTrigger).closest(nodeItemSelector).removeClass(c.submenuOpenCSS).find(childWrapSelector).stop(true).slideUp(300);
					} else {
						var $targetNode = $(elem).closest(nodeItemSelector);
						$targetNode.siblings(nodeItemSelector).removeClass(c.submenuOpenCSS).find(childWrapSelector).stop(true).slideUp(300);
						if($targetNode.hasClass(c.submenuOpenCSS)) {
							$targetNode.removeClass(c.submenuOpenCSS).find(childWrapSelector).stop(true).slideUp(300);
						} else {
							$targetNode.addClass(c.submenuOpenCSS).find(childWrapSelector).stop(true).slideDown(300);
						}
					}
				}
				function attachEventsWin() {
					if ( c.menuActive===true ){
						return;
					}
					$(c.menuTrigger).on(c.triggerEvent, toggleMenu);
					var toggleSubmenu = function(evt) {
						evt.preventDefault();
						openMenuNode(evt.target);
					};
					$(c.submenuTrigger).on('click.subMenu', toggleSubmenu);
				}
				function detachEventsWin() {
					if ( c.menuActive===false ){
						return;
					}
					$(c.menuTrigger).off(c.triggerEvent);
					$(c.submenuTrigger).off('click.subMenu');
				}
				function handleEventsWinResize() {
					html.removeClass( c.menuCSS );
					html.removeClass( c.scrollCSS );
					if (win.width() > c.maxW-1) {
						detachEventsWin();
						c.menuActive = false;
					} else {
						attachEventsWin();
						c.menuActive = true;
					}
				}
				function handleEventsWinScroll() {
					var sY = win.scrollTop();
					var hasPassed = html.hasClass(c.scrollCSS);

					if ( !hasPassed && sY >= c.scrollH ) {
						html.addClass( c.scrollCSS );
					} else if ( hasPassed && sY < c.scrollH ) {
						html.removeClass( c.scrollCSS );
					}
				}

				handleEventsWinResize();
				handleEventsWinScroll();

				win.on('resize', handleEventsWinResize);
				win.on('scroll', handleEventsWinScroll);
			})();
		} // responsiveMenu()




		,tabs: function() {
			var $elem = $('.tab-wrap');
			if ($elem.length < 1){
				return;
			}

			var  win = plauditConfig.win
				,body = plauditConfig.body
				,config = {
					 featureActive: false
					,maxW: 640
					,maxH: 400
					,state: 'desktop'
				}
				,$hscrollArea  = $elem.find('.tab-nav')
				,$hscrollItems = $hscrollArea.find('a')
				,$hscrollWrap  = $hscrollArea.find('.nav');

			// code independence
			var  $tabs = $hscrollItems
				,$content = $elem.find('.tab-content');

			/* this is very similar to other code here. */
			var tabScroller = {
				 center: 0
				,itemWidth: function (){ return 200; }
				,scrollWidth: function (){ return 120; }
				,numberVisible: function (){ return 1; }
				,pages: 1
				,pageCurrent: 1
				,wrapWidth: null
				,controlCreated: false
				,itemsCount: $hscrollItems.length
				,center: function(item){
					if (typeof item === 'undefined'){
						$elem = $hscrollItems.filter("[data-tab="+(this.pageCurrent-1)+"]");
					} else {
						$elem = item;
					}
					var areaCenter = $($hscrollArea).width()/2;
					var itemCenter = $elem.parent().width()/2;
					var itemLeft =	$elem.position().left;

					this.pageCurrent = $elem.data('tab')+1;
					$hscrollWrap.stop().animate({left: areaCenter-itemCenter-itemLeft });
				}
				,init: function(){
					this.reset();
					this.setPages();
					this.setWidth();
				}
				,reset: function(){
					$hscrollWrap.attr('style', '');
				}
				,setPages: function(){
					this.pages = Math.ceil( this.itemsCount / this.numberVisible() );
				}
				,setWidth: function(){
					if (plauditConfig.widthUnder['640']){
						$hscrollWrap.width( (this.itemsCount) * this.itemWidth() );
					}
					this.center();
				}
			} // tabScroller

			function tabSwitcher(elem){
				var $this = $(elem);

				$tabs.parent().removeClass('active');
				$this.parent().addClass('active');

				$content.children().hide();
				$content.find('#tabPane-' + $this.data('tab')).show();

				tabScroller.center($this);
			} // tabSwitcher

			function handleEventWinResize(){
				if (plauditConfig.widthUnder['640']){
					tabScroller.setWidth();
				} else {
					tabScroller.reset();
				}
			} // handleEventWinResize

			$tabs.on('click', function(e){
				e.preventDefault();
				tabSwitcher(this);
			});

			tabScroller.init();
			tabSwitcher( $tabs[0] );

			win.on('resize.tabs', handleEventWinResize);
		} // tabs()

	};
})(jQuery);

Analytics.getInstance().setOptions( {$contentArea:".body"} );

jQuery(function(){
	plauditUI.common();
	plauditUI.responsiveMenu();
	plauditUI.carousel();
	plauditUI.cardFlip();
	plauditUI.tabs();
	plauditUI.fileUploader('.amazon-file-upload');
	plauditUI.deleteFileButtonPrompt();
	plauditUI.formCustomURL('.yourCustomUrl');
	plauditUI.bannerSelector('#imageBGraphicSelector');

	plauditUI.copyToClipboard();

	plauditUI.datePicker();
});

window.plauditUI = plauditUI;
